export default __webpack_public_path__ + "static/media/wizelineAcademy.ce241264.png";